import { Component } from '@angular/core';

@Component({
  selector: 'app-setup-account-successfully',
  templateUrl: './setup-account-successfully.component.html',
  styleUrls: ['../../auth.scss', './setup-account-successfully.component.scss'],
})
export class SetupAccountSuccessfullyComponent {}
